///
/// EarthBrowser Admin Dashboard - Authenticated API
///
/// Created: 2025-11-27
/// Copyright (c) 2025 Geodata Labs
///

import { createApi } from '@reduxjs/toolkit/query/react'
import { bearerTokenQuery } from './bearerTokenQuery'

export const authenticatedApi = createApi({
  reducerPath: "authenticatedApi",
  baseQuery: bearerTokenQuery,
  tagTypes: [
    "FeatureFlags",
    "UserProfile",
    "UserAccounts",
    "AdminGeoPackages",
    "OpsTasks",
    "OpsSummary",
    "OpsHealth",
    "EmailDeliverability",
    "EmailSuppressions",
    "TrialAbuse",
    "Insights",
  ],
  endpoints: () => ({}),
})

